/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SoftwareVersionsState, SOFTWARE_VERSIONS_KEY } from './software-versions.reducer';

const getState = createFeatureSelector<SoftwareVersionsState>(SOFTWARE_VERSIONS_KEY);
export const getSoftwareVersionState = createSelector(getState, (state: SoftwareVersionsState) => state.versions);
